import * as React from 'react';
import { ThemeProvider } from '@websky/core/src/theme';
import theme from '../../theme/theme';
import Head from '../Head';
import { Forms } from '@websky/core';
import { Tab } from '@websky/core/src/Forms/Forms';
import { default as SearchForm } from '@websky/core/src/SearchForm';
import Booking from '@websky/core/src/Forms/Booking/Booking';
import Checkin from '@websky/core/src/Forms/Checkin/Checkin';
import { useConfig } from '@websky/core/src/context';
import { RenderersProvider } from '@websky/core/src/renderProps';
import { renders as renderProps } from '../../renders';

import '../../theme/variables.css';
import { BootstrapGate } from '@websky/core/src/__fsd__/shared/ui';

const SearchFormComponent: React.FC = () => {
	const { accountURL } = useConfig().Engine;

	const customTabs: Tab[] = [
		{ title: 'Buy ticket', value: 'search', content: <SearchForm /> },
		{ title: 'Register for a flight', value: 'checkin', content: <Checkin /> },
		{ title: 'Order search', value: 'booking', content: <Booking /> },
		{ title: 'Personal account', value: 'account', action: { href: accountURL } }
	];

	return (
		<ThemeProvider value={theme}>
			<RenderersProvider value={renderProps}>
				<BootstrapGate>
					<Head />
					<Forms customTabs={customTabs} />
				</BootstrapGate>
			</RenderersProvider>
		</ThemeProvider>
	);
};

export default SearchFormComponent;
